import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_SERVER;
const KEY = 'cvdl_admin_token';

export const getAdminToken = () => {
  try { return localStorage.getItem(KEY); } catch { return null; }
};
export const setAdminToken = (t) => {
  try { localStorage.setItem(KEY, t); } catch { /* modo privado */ }
};
export const clearAdminToken = () => {
  try { localStorage.removeItem(KEY); } catch { /* modo privado */ }
};

const http = axios.create({ baseURL: `${API}/admin/cvdl`, timeout: 15000 });

http.interceptors.request.use(cfg => {
  const t = getAdminToken();
  if (t) cfg.headers['x-cvdl-admin'] = t;
  return cfg;
});

http.interceptors.response.use(r => r, err => {
  const e = new Error(err.response?.data?.message || err.message);
  e.status = err.response?.status;
  e.code = err.response?.data?.error;
  if (e.status === 401) clearAdminToken();
  return Promise.reject(e);
});

// Descarga un CSV respetando el header de autorización: no se puede abrir la
// URL en una pestaña porque el token no viajaría.
async function descargarCsv(ruta, nombre) {
  const r = await http.get(ruta, { responseType: 'blob' });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement('a');
  a.href = url; a.download = nombre;
  document.body.appendChild(a); a.click(); a.remove();
  URL.revokeObjectURL(url);
}

export const adminApi = {
  async armar(pin) {
    const { data } = await http.post('/armar', { pin });
    return data;
  },
  async ruletaTablero() {
    const { data } = await http.get('/ruleta/tablero');
    return data;
  },
  async gemelosTablero() {
    const { data } = await http.get('/gemelos/tablero');
    return data;
  },
  async reporteEmparejado() {
    const { data } = await http.get('/gemelos/reporte-emparejado');
    return data;
  },
  async cambiarPeso(id, cambios) {
    const { data } = await http.patch(`/ruleta/premios/${id}`, cambios);
    return data;
  },
  // alcance: 'todo' | 'hoy'. El backend recorta a 600 giros y avisa si trunca.
  async ruletaGiros(alcance = 'todo') {
    const { data } = await http.get('/ruleta/giros', {
      params: alcance === 'hoy' ? { dia: 'hoy' } : {},
    });
    return data;
  },
  async resetearDia(forzar = false) {
    const { data } = await http.post('/ruleta/reset-day', { forzar });
    return data;
  },
  async entregadas() {
    const { data } = await http.get('/gemelos/entregadas');
    return data;
  },
  async reenviarAviso(numero) {
    const { data } = await http.post(`/gemelos/${numero}/reenviar`);
    return data;
  },
  async liberarPistas(numero, avisar = true) {
    const { data } = await http.post(`/gemelos/${numero}/liberar`, { avisar });
    return data;
  },
  exportarRuleta: () => descargarCsv('/ruleta/export.csv', 'ruleta-cvdl-2026.csv'),
  exportarGemelos: () => descargarCsv('/gemelos/export.csv', 'gemelos-cvdl-2026.csv'),
};
